import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import { Input } from 'semantic-ui-react';
import onClickOutside from 'react-onclickoutside';

import CommonErrorIcon
  from 'components/common/CommonErrorIcon';

import './CommonInputField.css';

const ENTER_KEY = 13;

class CommonInputField extends Component {
  static propTypes = {
    executedFunction: PropTypes.func.isRequired,
    validationFunction: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    initialValue: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    serverErrors: PropTypes.string,
    editIcon: PropTypes.bool,
  };

  static defaultProps = {
    initialValue: null,
    placeholder: null,
    disabled: null,
    label: null,
    maxLength: null,
    serverErrors: null,
    editIcon: null,
    onChange: null,
  };

  state = {
    prevValue: '',
    currentValue: '',
    validationError: null,
    serverError: null,
    inputActive: false,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.initialValue) {
      this.setState({
        prevValue: this.props.initialValue,
        currentValue: this.props.initialValue,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentValue && !this.state.currentValue) {
      this.setState({ validationError: null });
    }

    if (prevProps.initialValue !== this.props.initialValue) {
      this.setState({ currentValue: this.props.initialValue, serverError: this.props.serverErrors});
    }

    if (this.props.serverErrors && this.props.serverErrors !== this.state.serverError ) {
      this.setState({serverError: this.props.serverErrors});
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handlePencilEditClick = () => {
    this.setState({ inputActive: true });
    if (this.inputEditFieldRef) {
      this.inputEditFieldRef.current.focus();
    }
  };

  executeValidation = () => {
    if (this.props.validationFunction) {
      this.setState({ validationError: this.props.validationFunction(this.state.currentValue) });
    }
  };

  changeValue = () => {
    const { executedFunction } = this.props;
    const { prevValue, currentValue, validationError } = this.state;

    if (currentValue !== prevValue) {
      this.setState({ prevValue: currentValue });
      if (!validationError) { executedFunction(currentValue); }
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.executeValidation();
      this.changeValue();
    }
  };

  handleClickOutside = () => {
    this.executeValidation();
    this.changeValue();
    this.setState({ inputActive: false });
  };

  render() {
    const {
      onChange,
      placeholder,
      disabled,
      label,
      maxLength,
      editIcon,
    } = this.props;

    const {
      currentValue,
      validationError,
      serverError,
      inputActive,
    } = this.state;

    return (
      <div className="common-input-field__component">
        {/* Input Label */}
        {label && <div className="label">{label}</div>}

        {/* Input Wrapper */}
        <div className={`input-wrapper${(validationError || serverError) ? ' error' : ''}`}>
          <Input
            value={currentValue}
            placeholder={placeholder}
            disabled={disabled}
            onChange={e => {
              e.preventDefault();
              if (onChange) {
                onChange(e.target.value);
              }
              if (
                maxLength &&
                maxLength > 0 &&
                e.target.value.length > maxLength
              ) return;
              this.setState({ currentValue: e.target.value });
            }}
            onBlur={() => { this.handleClickOutside(); }}
            ref={this.inputEditFieldRef}
          />

          {/* Error Icon */}
          {(validationError || serverError) &&
            <CommonErrorIcon errorText={validationError || serverError} />
          }

          {/* Edit Icon */}
          {editIcon &&
            !inputActive &&
            !validationError &&
            !serverError &&
            !disabled &&
            <div
              className="pencil-icon"
              onClick={this.handlePencilEditClick}
            />
          }
        </div>

        {/* Max Length Indicator */}
        {maxLength &&
          <div className="words-counter">
            {maxLength - (currentValue && currentValue.length)} characters left
          </div>
        }
      </div>
    );
  }
}

export default onClickOutside(CommonInputField);
